<template lang="pug">
  footer.sticky-footer.bg-white
    .copyright.text-center.my-auto
      span Copyright © {{(new Date()).getFullYear()}} ReturnPostage Inc.
</template>

<script>
export default {
  name: 'DashboardFooter',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .sticky-footer{
    margin-top:20px;
  }

</style>
